import React from 'react';
import styles from './HowItWorksSection.module.scss';
import SectionBadge from '../components/SectionBadge';

const HowItWorksSection = () => {
  const steps = [
    {
      title: 'Add your website URL',
      description: 'Vocable scans your site to learn your tone, style, and key messages, so every piece of content matches your brand.',
    },
    {
      title: 'Create your campaign',
      description: "Tell Vocable what you want to create, pick the channels you're creating for, and it instantly builds your content calendar.",
    },
    {
      title: 'Edit, organize, and publish',
      description: 'Refine your content, manage your campaigns with ease, and publish directly from a single dashboard.',
    },
  ];

  return (
    <section className={styles.howItWorks}>
      <div className={styles.container}>
        <div className={styles.header}>
          <SectionBadge>How it works</SectionBadge>
          <h2 className={styles.headline}>
            Create high converting content at scale in three simple steps.
          </h2>
        </div>

        <div className={styles.stepsImage}>
          <img
            src="/Images/HowItWorks.png"
            alt="Step 1: Add your website URL, Step 2: Create your campaign, Step 3: Edit, organize, and publish"
            className={styles.stepsImg}
          />
        </div>

        <div className={styles.stepsText}>
          {steps.map((step, index) => (
            <div key={index} className={styles.stepTextItem}>
              <h3 className={styles.stepTitle}>{step.title}</h3>
              <p className={styles.stepDescription}>{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
